//
import { createContext } from 'react'

const WizardHeaderContext = createContext({
    headerComponent: null,
    isInstallSuccess: false,
})

export default WizardHeaderContext
